import { render, staticRenderFns } from "./FloatingHeader.vue?vue&type=template&id=0cf20cea"
import script from "./FloatingHeader.vue?vue&type=script&lang=js"
export * from "./FloatingHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports